import { useQuery } from "@tanstack/react-query";
import { getUserPreferences } from "../api/USERS/users";

export function useGetUserPreferences(userId) {
  return useQuery({
    queryKey: ["userPreferences", String(userId)],
    queryFn: () => getUserPreferences(userId),
    enabled: !!userId,
  });
}
